import { Box, Image } from "@chakra-ui/react";
import { DarkMode } from "@chakra-ui/system";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import CenteredContent from "../CenteredContent";

/**
 * @typedef {Object} Props
 * @property {string} src
 * @property {React.ReactNode} children
 *
 * @param {Props} props
 */
function Landing({ src, children }) {
  return (
    <DarkMode>
      <Box backgroundColor="brandPrimary.500">
        <CenteredContent maxWidth="1600px">
          <Box
            position="relative"
            backgroundImage={`url(${src})`}
            backgroundSize="cover"
            backgroundPosition="center">
            <Box
              backgroundImage={generateFrontPath({
                id: "internal-assets",
                parameters: { filePath: "bubble-2.svg" },
                includeBasePath: true,
              })}
              backgroundSize="auto 100%"
              backgroundRepeat="no-repeat"
              minH="293px">
              <Box px="1rem">
                <CenteredContent maxWidth="1280px">
                  <Box pt={{ base: "4rem", lg: "7rem" }}>{children}</Box>

                  <Image
                    position="absolute"
                    bottom="-1px"
                    left="0"
                    right="0"
                    pointerEvents="none"
                    src={generateFrontPath({
                      id: "internal-assets",
                      parameters: { filePath: "wave-white-top.svg" },
                      includeBasePath: true,
                    })}
                    alt="wave"
                  />
                </CenteredContent>
              </Box>
            </Box>
          </Box>
        </CenteredContent>
      </Box>
    </DarkMode>
  );
}

export default Landing;
